module.exports = __webpack_public_path__ + "img/bar02.40fbba3b.png";